import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@as/cotopaxi';
import AsNumeral from '../../vendors/asNumeral';
import { usePriceProps } from '../../hooks/usePriceProps';
import { Price } from '@yonderland/andes-react';
export const PromoBasketPopupPrice = ({ priceInformation }) => {
    var _a, _b, _c;
    const priceActual = {
        formattedPrice: `${(_a = priceInformation.prices) === null || _a === void 0 ? void 0 : _a.SELL.original},-`,
    };
    const pricePrevious = ((_c = (_b = priceInformation.prices) === null || _b === void 0 ? void 0 : _b.STD) === null || _c === void 0 ? void 0 : _c.original)
        ? {
            formattedPrice: AsNumeral.formatAsCurrency(priceInformation.prices.STD.original),
        }
        : undefined;
    const priceProps = usePriceProps({
        priceInformation,
        enablePriceReference: false,
        fallbackPriceViewModel: {
            priceActual,
            pricePrevious,
        },
    });
    return (_jsx(Box, { mobile: { spacing: { marginBottom: 0.5 } }, tablet: { spacing: { marginBottom: 2 } }, children: !!priceProps && _jsx(Price, Object.assign({}, priceProps)) }));
};
